import { defineMessages } from "react-intl";
export const messages = defineMessages({
    scanRequestsPageTitle: {
        id: "scanRequests.layout.page.title",
        defaultMessage: "Scan Requests",
    },
    scanRequestsCompletedSearch: {
        id: "scanRequests.completed.search.placeholder",
        defaultMessage: "Search for Requests",
    },
    scanRequestsSearch: {
        id: "scanRequests.requests.search.placeholder",
        defaultMessage: "Search for Requests",
    },
    errorMsgCommunity: {
        id: "scanRequests.layout.errorMsg.community",
        defaultMessage: "Failed to load communities",
    },
    communitySelectorPlaceholder: {
        id: "scanRequests.layout.communitySelector.emptyPlaceholder",
        defaultMessage: "Filter by Community",
    },
    communitySelectorPlaceholderAddMore: {
        id: "scanRequests.layout.communitySelector.contentPlaceholder",
        defaultMessage: "+ Add Community",
    },
    scanRequestsTabRequests: {
        id: "scanRequests.layout.tabs.requests",
        defaultMessage: "Requests",
    },
    scanRequestsTabRequested: {
        id: "scanRequests.layout.tabs.requested",
        defaultMessage: "Unscheduled Requests",
    },
    scanRequestsTabPastShoots: {
        id: "scanRequests.layout.tabs.pastShoots",
        defaultMessage: "Past Shoots",
    },
    scanRequestsUpcomingShoots: {
        id: "scanRequests.layout.tabs.upcomingShoots",
        defaultMessage: "Upcoming Shoots",
    },
});
